export default __webpack_public_path__ + "static/media/vikesh patel.9c6c92e4.jpg";